import Button from 'components/Button';
import PrivacyLink from 'components/PrivacyLink';
import { ChangeEvent, FormEvent } from 'react';
import styled from 'styled-components';
import { theme } from 'styles/theme';
import TextInput from '../Input';
import TextAreaInput from '../TextArea';

export interface IContact {
  name: string;
  company: string;
  email: string;
  phone: string;
  other: string;
}

export interface IContactForm {
  data: IContact;
  onSubmit: (data: IContact) => void;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  errors: IContact;
}

const ContactForm = ({ data, onSubmit, onChange, errors }: IContactForm): JSX.Element => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(data);
  };

  const inputs = [
    {
      name: 'name',
      autoComplete: 'name',
      label: 'Namn',
      value: data.name,
      type: 'text',
      error: errors.name,
      cap: true,
    },
    {
      name: 'company',
      autoComplete: 'organization',
      label: 'Företag',
      value: data.company,
      type: 'text',
      error: errors.company,
      cap: true,
    },
    {
      name: 'email',
      autoComplete: 'email',
      label: 'E-post',
      value: data.email,
      type: 'email',
      error: errors.email,
      cap: false,
    },
    {
      name: 'phone',
      autoComplete: 'tel',
      label: 'Telefon',
      value: data.phone,
      type: 'tel',
      error: errors.phone,
      cap: false,
    },
    {
      name: 'other',
      label: 'Övrigt',
      value: data.other,
      error: errors.other,
    },
  ];

  return (
    <Form onSubmit={handleSubmit}>
      {inputs.map((input, index) => (
        <GridItem key={index}>
          {input.name === 'other' ? (
            <TextAreaWrapper>
              <ContactTextArea
                placeholder="Är det något ni vill tillägga?"
                name={input.name}
                label={input.label}
                value={input.value}
                onChange={onChange}
              />
            </TextAreaWrapper>
          ) : (
            <ContactInput>
              <ContactTextInput
                $cap={input.cap}
                key={index}
                autoComplete={input.autoComplete}
                name={input.name}
                label={input.label}
                value={input.value}
                onChange={onChange}
                error={input.error}
              />
            </ContactInput>
          )}
        </GridItem>
      ))}
      <GridItem>
        <FormButton type="submit">Skicka er förfrågan</FormButton>
      </GridItem>

      <PrivacyLink />
    </Form>
  );
};

export default ContactForm;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${theme.contactForm.width};
  background-color: ${theme.colors.content_background};
  border: 1px solid ${theme.colors.border};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 30px;
  padding: 2rem 1.5rem;
  grid-gap: 1rem;
`;

const FormButton = styled(Button)`
  margin: 3.5rem auto 0;
`;

const GridItem = styled.div``;

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ContactTextArea = styled(TextAreaInput)`
  resize: none;
`;

const ContactInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ContactTextInput = styled(TextInput)<{ $cap?: boolean }>`
  text-transform: ${({ $cap }) => ($cap ? 'capitalize' : 'none')};
`;
